//const { forEach } = require("lodash");

angular.module('presas', [])
    .controller('PresasController', ['$scope', '$rootScope', '$routeParams', '$location', 'presasService', 'authenticationInfo', 'authenticationService', 'WeatherService', '$timeout', 'medicionesService',
        function ($scope, $rootScope, $routeParams, $location, presasService, authenticationInfo, authenticationService, WeatherService, $timeout, medicionesService) {


            // 1) Arrancamos cargando la presa y guardamos la PROMESA
            var presaReady = presasService.getPresa($scope.InfraestructuraId).then(function (response) {
                var presa = response.data || {};
                // Normaliza y guarda el Id
                $scope.PresaId = presa.Id || presa.PresaId || $scope.PresaId;
                return $scope.PresaId;
            });



            var pe = this;

            var infra = ($scope.$parent && $scope.$parent.infraestructura) ? $scope.$parent.infraestructura : null;
            var lat = infra && infra.PosicionamientoYInfraestructura ? infra.PosicionamientoYInfraestructura : 43.2627;
            var lon = infra && infra.PosicionamientoXInfraestructura ? infra.PosicionamientoXInfraestructura : -2.9253;

            pe.cargando = true;
            pe.error = null;
            pe.dias = [];             // etiquetas de días (YYYY-MM-DD)
            pe.mmDia = [];            // precipitación diaria sumada (mm)
            pe.total72h = 0;          // total 3 días
            pe.horas = [];            // timestamps horarios
            pe.mmHora = [];           // precipitación horaria (mm)

            WeatherService.getForecast(lat, lon)
                .then(function (data) {
                    if (data.daily && data.daily.time && data.daily.precipitation_sum) {
                        pe.dias = data.daily.time;
                        pe.mmDia = data.daily.precipitation_sum;
                        pe.total72h = pe.mmDia.reduce(function (a, b) { return a + b; }, 0);
                    }
                    if (data.hourly && data.hourly.time && data.hourly.precipitation) {
                        pe.horas = data.hourly.time;            // ISO strings
                        pe.mmHora = data.hourly.precipitation;  // mm por hora
                    }

                    // Renderiza gráficos cuando el DOM tenga los canvas
                    $timeout(function () {
                        //pe.renderChart();         // el diario que ya tenías
                        pe.renderHourlyChart();   // NUEVO: el horario
                    }, 0);
                })
                .catch(function (err) {
                    pe.error = 'No se pudo obtener el pronóstico de precipitación.';
                    // console.error(err);
                })
                .finally(function () {
                    pe.cargando = false;
                });

            //pe.renderChart = function () {
            //    var ctx = document.getElementById('precipitacionDiaChart');
            //    if (!ctx || !pe.mmDia || !pe.mmDia.length) return;

            //    // Si ya existe, destruye antes de recrear
            //    if (pe._chart) { pe._chart.destroy(); }

            //    pe._chart = new Chart(ctx, {
            //        type: 'bar',
            //        data: {
            //            labels: pe.dias,               // ej. ["2025-11-04","2025-11-05","2025-11-06"]
            //            datasets: [{
            //                label: 'Precipitación (mm)',
            //                data: pe.mmDia
            //            }]
            //        },
            //        options: {
            //            responsive: true,
            //            plugins: {
            //                legend: { display: false },
            //                title: { display: true, text: 'Precipitación prevista (próximos 3 días)' },
            //                font: { weight: 'bold' }, // <-- título en negrita
            //                datalabels: {
            //                    anchor: 'end',
            //                    align: 'top',
            //                    formatter: function (v) { return v.toFixed(1) + ' mm'; }
            //                }
            //            },
            //            scales: {
            //                y: {
            //                    beginAtZero: true,
            //                    ticks: { callback: function (v) { return v + ' mm'; } }
            //                }
            //            }
            //        }
            //    });
            //};


            // Utilidad local para formatear "dd/MM HH:mm"
            function formatHoraLabel(iso) {
                var d = new Date(iso);
                var dd = ('0' + d.getDate()).slice(-2);
                var mm = ('0' + (d.getMonth() + 1)).slice(-2);
                var hh = ('0' + d.getHours()).slice(-2);
                var mi = ('0' + d.getMinutes()).slice(-2);
                return dd + '/' + mm + ' ' + hh + ':' + mi;
            }

            pe.renderHourlyChart = function () {
                var el = document.getElementById('precipitacionHoraChart');
                if (!el || !pe.mmHora || !pe.mmHora.length) return;

                // filtra a partir de "ahora" y coge las próximas 72 horas
                var now = new Date();
                var pares = [];
                for (var i = 0; i < pe.horas.length; i++) {
                    var t = new Date(pe.horas[i]);
                    if (t >= now) pares.push({ t: pe.horas[i], v: pe.mmHora[i] });
                }

                var próximos = pares.slice(0, 72);

                var labels = próximos.map(function (p) { return formatHoraLabel(p.t); });
                var datos = próximos.map(function (p) { return p.v; });

                // destruye si ya existe
                if (pe._chartHour) { pe._chartHour.destroy(); }

                pe._chartHour = new Chart(el, {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Precipitación por hora (mm)',
                            data: datos
                        }]
                    },
                    options: {
                        responsive: true,
                        plugins: {
                            legend: { display: false },
                            title: { display: true, text: 'Precipitación prevista por horas (próximas 72 h)' },
                            font: { weight: 'bold' },
                            // Mejor desactivar datalabels aquí para no saturar
                            datalabels: {
                                display: false
                            },
                            tooltip: {
                                callbacks: {
                                    label: function (ctx) {
                                        var v = ctx.parsed.y;
                                        return (v != null ? v.toFixed(1) : '0.0') + ' mm';
                                    },
                                }
                            }
                        },
                        scales: {
                            x: {
                                grid: {
                                    display: false   // quita líneas verticales
                                },
                                ticks: {
                                    color: '#444',   // texto más visible
                                    font: {
                                        size: 11,
                                        weight: 'bold'
                                    },
                                    // muestra una etiqueta cada 6 horas aprox
                                    callback: function (val, idx) {
                                        if (idx % 6 === 0) {
                                            var label = this.getLabelForValue(val);
                                            // solo devuelve "dd/MM HHh"
                                            return label.replace(/(\d{2})\/(\d{2}) (\d{2}):\d{2}/, '$1/$2 $3h');
                                        }
                                        return '';
                                    },
                                    maxRotation: 45,  // texto inclinado
                                    minRotation: 45
                                },
                                title: {
                                    display: false,
                                    text: 'Fecha y hora',
                                }
                            },
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    callback: function (v) { return v + ' mm'; },
                                    color: '#444',
                                    font: {
                                        size: 11,
                                        weight: 'bold'
                                    },
                                },
                                title: {
                                    display: false,
                                    text: 'Precipitación (mm)',
                                }
                            }
                        }
                    }
                });
            };



            $scope.authentication = authenticationInfo;
            $scope.InfraestructuraId = $routeParams.id;
            $scope.PresaId = $routeParams.PresaId;
            $rootScope.PresaId = $routeParams.PresaId;

            presasService.getPresa($scope.InfraestructuraId) // <-- usa el nombre correcto
                .then(function (response) {
                    var presa = response.data;
                    // Determina el ID real de la presa
                    var presaId = presa.Id || presa.PresaId || $scope.PresaId;
                    if (!presaId) {
                        // sin id, no podemos seguir
                        return;
                    }
                    $scope.presaId = presaId;

                    presasService.getMedicionesSismografos(presaId)
                
                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.sismografos = data;


                            // Reinicia mensaje
                            $scope.mensajeSismografos = "";

                            if (!data.length) {
                                $scope.mensajeSismografos = "Sin registros en los últimos 3 días";
                                return; // no seguimos con el gráfico
                            }

                        })


                    presasService.getMedicionesAcelerografos(presaId)

                        .then(function (response) {
                            if (!response) return;
                            var data = response.data || [];
                            $scope.acelerografos = data;

                            // Reinicia mensaje
                            $scope.mensajeAcelerografos = "";

                            if (!data.length) {
                                $scope.mensajeAcelerografos = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }
                            


                        });


                    presasService.getMedicionesPluviometros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.pluviometros = data;

                            // Reinicia mensaje
                            $scope.mensajePluviometros = "";

                            if (!data.length) {
                                $scope.mensajePluviometros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }


                        })


                    presasService.getMedicionesLimnimetros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.limnimetros = data;

                            // Reinicia mensaje
                            $scope.mensajeLimnimetros = "";

                            if (!data.length) {
                                $scope.mensajeLimnimetros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }


                        })


                    presasService.getMedicionesAforadores(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.aforadores = data;


                            // Reinicia mensaje
                            $scope.mensajeAforadores = "";

                            if (!data.length) {
                                $scope.mensajeAforadores = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }
                        })


                    presasService.getMedicionesTermometros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.termometros = data;

                            // Reinicia mensaje
                            $scope.mensajeTermometros = "";

                            if (!data.length) {
                                $scope.mensajeTermometros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }
                            
                        })



                    presasService.getMedicionesInclinometros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.inclinometros = data;

                            // Reinicia mensaje
                            $scope.mensajeInclinometros = "";

                            if (!data.length) {
                                $scope.mensajeInclinometros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })



                    presasService.getMedicionesExtensometros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.extensometros = data;

                            // Reinicia mensaje
                            $scope.mensajeExtensometros = "";

                            if (!data.length) {
                                $scope.mensajeExtensometros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })


                    presasService.getMedicionesClinometros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.clinometros = data;

                            // Reinicia mensaje
                            $scope.mensajeClinometros = "";

                            if (!data.length) {
                                $scope.mensajeClinometros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })



                   presasService.getMedicionesPendulos(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.pendulos = data;

                            // Reinicia mensaje
                            $scope.mensajePendulos = "";

                            if (!data.length) {
                                $scope.mensajePendulos = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })



                    presasService.getMedicionesPiezometros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.piezometros = data;

                            // Reinicia mensaje
                            $scope.mensajePiezometros = "";

                            if (!data.length) {
                                $scope.mensajePiezometros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })



                    presasService.getMedicionesTurbidimetros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.turbidimetros = data;

                            // Reinicia mensaje
                            $scope.mensajeTurbidimetros = "";

                            if (!data.length) {
                                $scope.mensajeTurbidimetros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })



                    presasService.getMedicionesSensores(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.sensores = data;

                            // Reinicia mensaje
                            $scope.mensajeSensores = "";

                            if (!data.length) {
                                $scope.mensajeSensores = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })


                    presasService.getMedicionesManometros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.manometros = data;

                            // Reinicia mensaje
                            $scope.mensajeManometros = "";

                            if (!data.length) {
                                $scope.mensajeManometros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })




                    presasService.getMedicionesCelulaspresion(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.celulaspresion = data;

                            // Reinicia mensaje
                            $scope.mensajeCelulaspresion = "";

                            if (!data.length) {
                                $scope.mensajeCelulaspresion = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })




                    presasService.getMedicionesSensoresPosicion(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.sensoresposicion = data;

                            // Reinicia mensaje
                            $scope.mensajeSensoresPosicion = "";

                            if (!data.length) {
                                $scope.mensajeSensoresPosicion = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })



                    presasService.getMedicionesElongametros(presaId)

                        .then(function (response) {
                            if (!response) return; // por si arriba hicimos return
                            var data = response.data || [];
                            $scope.elongametros = data;

                            // Reinicia mensaje
                            $scope.mensajeElongametros = "";

                            if (!data.length) {
                                $scope.mensajeElongametros = "(Sin registros en los últimos 3 días)";
                                return; // no seguimos con el gráfico
                            }

                        })



                })

        presasService.getMensajes($scope.PresaId)
            .then(function (response) {
                var data = response.data;
                $scope.mensajes = data;
            });

        $scope.volver = function () {
            $rootScope.inspeccionUrl == false;
            $rootScope.parteUrl == false;
            $location.path('/categorias');
        };

    }]);

